import { useState } from 'react'

import { connect } from 'react-redux'
import * as actions from '../../actions/reports'

import PaymentsReports from './payments';
import ProductsReports from './products';
import DeliveriesByBairroEntregadorReports from './deliveriesByBairro';
import { verifyAdmin } from '../../utils/verify-admin';

function Reports({ admin, paymentReports, productsReports, deliveriesByBairroEntregador, history, getReportPayment, getReportProducts,
                   getReportDeliveriesByBairroEntregador, clearReports, generatePdfProductsReport, generatePdfDeliveriesByBairroEntregadorReport }){

  const [loadingPayments, setLoadingPayments] = useState(false);
  const [loadingProducts, setLoadingProducts] = useState(false);
  const [loadingDeliveriesByBairro, setLoadingDeliveriesByBairro] = useState(false);

  function handleFindPayments({ initial, final }) {
    setLoadingPayments(true)
    getReportPayment({ initial, final }, admin.loja, () => setLoadingPayments(false));
  }

  function handleFindProducts({ initial, final, shippingPeriod }) {
    setLoadingProducts(true)
    getReportProducts({ initial, final, shippingPeriod }, admin.loja, () => setLoadingProducts(false));
  }

  function handleFindDeliveriesByBairro({ initial, final }) {
    setLoadingDeliveriesByBairro(true)
    getReportDeliveriesByBairroEntregador({ initial, final }, admin.loja, () => setLoadingDeliveriesByBairro(false));
  }

  return (
    <div className="Reports container-centered">
      <div className="wrapper">
        <h2><i className="fas fa-file-contract"></i> Relatórios</h2>

        {/*{ (admin && verifyAdmin(admin, 'owner')) && (*/}
          <PaymentsReports loading={loadingPayments} reports={paymentReports} handleFind={handleFindPayments} clearReports={clearReports} />
        {/*)}*/}
        <ProductsReports loading={loadingProducts} reports={productsReports} handleFind={handleFindProducts} clearReports={clearReports} generatePdfProductsReport={generatePdfProductsReport} loja={admin && admin.loja} />
        <DeliveriesByBairroEntregadorReports
          loading={loadingDeliveriesByBairro}
          reports={deliveriesByBairroEntregador}
          handleFind={handleFindDeliveriesByBairro}
          clearReports={clearReports}
          generatePdfDeliveriesByBairroEntregadorReport={generatePdfDeliveriesByBairroEntregadorReport}
          loja={admin && admin.loja}
        />
        {/*<ReOfferReport loading={loadingReOffer} reports={reOfferReports} handleFindOf={handleFindReOffers} clearReports={clearReports} />*/}
      </div>
    </div>
  )
}

const mapStateToProps = state => ({
  paymentReports: state.reports.payments,
  productsReports: state.reports.products,
  deliveriesByBairroEntregador: state.reports.deliveriesByBairroEntregador,
  reOfferReports: state.reports.reOfferReducer,
  admin: state.auth.usuario
});

export default connect(mapStateToProps, actions)(Reports);